import { useState, useEffect, useRef } from "react"
import { HStack } from "@chakra-ui/react"
import { Form, Icon } from "components"

export default function Searchable({ value, children, setValue = () => {}, ...props}){
    const [localValue, setLocalValue] = useState(value ?? '')
    const timeout = useRef(null)

    useEffect(() => { setLocalValue(value ?? '') }, [value])

    const onChange = event => {
        const searchText = event.target.value
        setLocalValue(searchText)
        clearTimeout(timeout.current)
        timeout.current = setTimeout(function(){ if(searchText.length >= 3 || searchText.length <= 0) setValue(searchText) } , 1000)
    }

    return(
    <HStack marginTop={4} borderRadius={4} p={2} backgroundColor="rgba(0,0,0,0.1)">
        <Icon name="search" ml={2} fontSize="25px" color="GrayText" />
        <Form.Text type="search" autoComplete="off" onChange={onChange} value={localValue} fontWeight="bold" border={0} {...props} />
        {children}
    </HStack>
    )
}